import type { AiqIndividualReportResponse } from '@quebon/shared-learning'
import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'

// Re-export for page components that only need the report type.
export type { AiqIndividualReportResponse }

/**
 * AIQ API (Super Admin).
 *
 * Super Admin은 조직/학습자 제한 없이 모든 AIQ 리포트를 조회할 수 있어야 하므로
 * 백엔드 /aiq/report/admin/individual 엔드포인트를 그대로 사용한다.
 */
export const aiqApi = {
  /**
   * Admin용 개인 AIQ 리포트 조회.
   * Pre-AIQ만 완료된 경우에도 조회 가능.
   * productId 또는 classProductId 중 하나는 필수 (classProductId만 전달 시 backend가 productId 자동 조회).
   */
  getAdminIndividualReport: (userId: number, productId?: number, classProductId?: number) => {
    const params = new URLSearchParams({ userId: String(userId) })
    if (productId) params.append('productId', String(productId))
    if (classProductId) params.append('classProductId', String(classProductId))
    return apiClient.get<ApiResponse<AiqIndividualReportResponse>>(`/aiq/report/admin/individual?${params}`)
  },
}
